
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Package } from "lucide-react";

interface Shipment {
  id: number;
  trackingNumber: string;
  shipmentDate: string;
  status: string;
  medications: string;
}

interface PatientShipmentsTabProps {
  shipments: Shipment[];
  onViewAll: () => void;
}

const PatientShipmentsTab = ({ shipments, onViewAll }: PatientShipmentsTabProps) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString();
  };

  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case 'delivered': return 'bg-green-100 text-green-800';
      case 'shipped': return 'bg-blue-100 text-blue-800';
      case 'pending': return 'bg-yellow-100 text-yellow-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <Card>
      <CardHeader>
        <div className="flex justify-between items-center">
          <CardTitle className="flex items-center">
            <Package className="h-5 w-5 mr-2" />
            Shipments
          </CardTitle>
          <Button variant="outline" size="sm" onClick={onViewAll}>
            View All
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {shipments.map((shipment) => (
            <div key={shipment.id} className="p-4 border border-slate-200 rounded-lg">
              <div className="flex justify-between items-start mb-2">
                <div className="font-medium">#{shipment.trackingNumber}</div>
                <Badge className={getStatusColor(shipment.status)}>
                  {shipment.status}
                </Badge>
              </div>
              <div className="text-sm text-slate-600 mb-1">
                {shipment.medications}
              </div>
              <div className="text-sm text-slate-500">
                Shipped: {formatDate(shipment.shipmentDate)}
              </div>
            </div>
          ))}
          {shipments.length === 0 && (
            <div className="text-center py-8 text-slate-500">
              No shipments available
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default PatientShipmentsTab;
